<template>
  <div>{{ item.operation.days }} days</div>
</template>

<script>
export default {
  name: "order-status-yard-days",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
